




import Certificate from "./Certificate.vue";
import CertificateMobile from "./mobile/certificate/CertificateMobile.vue";
import ResponsiveLayout from "../mixin/ResponsiveLayout.vue";

export default {
  components: {
    ResponsiveLayout,
    Certificate,
    CertificateMobile,
  },
  data() {
    return {
      CertificateMobile,
      Certificate,
    };
  },
};
